import { AppThunkDispatch, RootState } from 'store/store';
import { EMAIL_STORE_ACTION_TYPE } from 'store/email/email.type';
import { showSnackbar } from 'store/snackbar/snackbar.action';

/**
 * Action creator for updating the email template fields.  Currently replaces the entire payload.template.[langCode],
 * but when we understand how to serialize better, this can be adjusted.
 * */
export function updateEmailTemplateData(
  journeyEmailTemplateData: Record<string, string>,
  journeyEmailTemplateId: string,
  refId: string,
  language: string,
) {
  return (dispatch: AppThunkDispatch, getState: () => RootState) => {
    const emailStateItem = getState().te.email.byRefId[refId];
    dispatch({
      type: EMAIL_STORE_ACTION_TYPE.UPDATE_EMAIL,
      payload: {
        ...emailStateItem,
        payload: {
          ...emailStateItem.payload,
          template: {
            ...emailStateItem.payload?.template,
            [language]: {
              ...emailStateItem.payload?.template?.[language],
              journeyEmailTemplateId,
              journeyEmailTemplateData: {
                languageCode: language,
                ...journeyEmailTemplateData,
              },
            },
          },
        },
      },
    });
    dispatch(
      showSnackbar({
        content: 'Changes have been applied to the email node',
        type: 'success',
      }),
    );
  };
}
